module.exports = __webpack_public_path__ + "static/media/ZEPICK.5ddaaf2a.svg";